import { useTranslation } from 'react-i18next';
import SVGIcon from '~/components/ui/Icons/SVGIcon';
import { cityText } from '~/components/utils/officeData';
import { useLanguageParam } from '~/config/i18n';
import type { CoreOfficeDataType } from '~/types/offices';

const OfficeLocation = ({ office }: { office: CoreOfficeDataType }) => {
  const { t } = useTranslation();
  const lang = useLanguageParam();

  return (
    <div className="py-8 fo-border-top-sm border-grey-200">
      <h3 className="fo-display-3 -medium mb-5">
        {`${office.pro ? `${t('global.common.coworking')}, ` : ''}
        ${cityText(office, lang)}, ${office.addressDetails.country}`}
      </h3>
      <div className="map-wrapper my-3 position-relative">
        <img
          className="map-image w-100 rounded-4 position-absolute top-50 start-50 border border-grey-200"
          src={office.mapLocation}
          alt="placeholder"
        />
        <div className="circle-map-pin position-absolute top-50 start-50 ">
          <div className="p-6 rounded-pill circle-map-pin__highlight-15">
            <div className="p-2 rounded-pill circle-map-pin__highlight-20">
              <div className="p-2 rounded-pill shadow-sm bg-white fo-border-sm border-grey-200">
                <SVGIcon
                  iconType="pin-map"
                  fill="#6610F2"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {office.transportStations.length > 0 && (
        <div className="row mt-4">
          {office.transportStations.map((station) => (
            <div
              className="d-flex col-6 col-lg-4 mt-5 gap-1 pe-3 flex-column"
              key={station.name}
            >
              <span className="text-2">{station.name}</span>
              <span className="caption -regular color-grey-500">{`${station.walkingDuration} min ${t(
                'office.distance.onFoot',
              )}`}</span>
              <div className="d-flex">
                {station.lines.map((lineId) => (
                  <img
                    key={`${station.name} - ${lineId}`}
                    alt={`${station.name} - ${lineId}`}
                    className="transport-line-icon me-1"
                    src={`/media/transportLines/paris/${lineId}.svg`}
                    style={{ height: '1.25rem', width: '1.25rem' }}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OfficeLocation;
